export const SELF_EXCLUSION_REVIEW_EMAIL = 'selfexclusion@thirstycamel.com.au'
export const SELF_EXCLUSION_REVIEW_SUBJECT = 'Self Exclusion Review Request'

export const getSelfExclusionReviewRequestHelpText = () =>
  `Email ${SELF_EXCLUSION_REVIEW_EMAIL} with the subject ${SELF_EXCLUSION_REVIEW_SUBJECT}.`
